module.exports = __webpack_public_path__ + "images/icons_v2/timer-f861cf3a.svg";